console.log("loading src/js/index.js - Ready");
console.log("version 1.0.3");

// document.write(
//   '<script src="http://' +
//     (location.host || "localhost").split(":")[0] +
//     ':35729/livereload.js?snipver=1"></' +
//     "script>"
// );

// document.addEventListener("DOMContentLoaded", function () {
//   const tabs = document.querySelectorAll(".tab");
//   const tabContents = document.querySelectorAll(".tab-content");

//   tabs.forEach((tab) => {
//     tab.addEventListener("click", function () {
//       const target = this.dataset.tab;

//       tabs.forEach((t) => t.classList.remove("active"));
//       tabContents.forEach((tc) => tc.classList.remove("active"));

//       this.classList.add("active");
//       document.getElementById(target).classList.add("active");
//     });
//   });
// });

// mobile menu
document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
  const hamburgerIcon = mobileMenuToggle.querySelector(".hamburger");
  const closeIcon = mobileMenuToggle.querySelector(".close");
  const firstMobile = document.querySelector(".first_mobile");
  const secondMobile = document.querySelector(".second_mobile");
  const mobileMenu = document.querySelector(
    ".mod_navigation.mobile-only > .wrapper"
  );

  function openMenu() {
    firstMobile.classList.add("show");
    secondMobile.classList.add("show");
    hamburgerIcon.classList.add("animate");
    closeIcon.classList.add("animate");
    mobileMenuToggle.classList.add("active");
    mobileMenu.classList.add("active");
  }

  function closeMenu() {
    firstMobile.classList.remove("show");
    secondMobile.classList.remove("show");
    hamburgerIcon.classList.remove("animate");
    closeIcon.classList.remove("animate");
    mobileMenuToggle.classList.remove("active");
    mobileMenu.classList.remove("active");
  }

  function toggleMenu() {
    if (mobileMenu.classList.contains("active")) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  mobileMenuToggle.addEventListener("click", function (event) {
    event.stopPropagation();
    toggleMenu();
  });

  document.body.addEventListener("click", function (event) {
    if (
      mobileMenu.classList.contains("active") &&
      !mobileMenu.contains(event.target) &&
      !mobileMenuToggle.contains(event.target)
    ) {
      closeMenu();
    }
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   const mobileMenuToggle = document.querySelector(".mobile-menu-toggle");
//   const hamburgerIcon = mobileMenuToggle.querySelector(".hamburger");
//   const closeIcon = mobileMenuToggle.querySelector(".close");
//   const firstMobile = document.querySelector(".first_mobile");
//   const secondMobile = document.querySelector(".second_mobile");
//   const mobileMenu = document.querySelector(
//     ".mod_navigation.mobile-only > .wrapper"
//   );

//   function toggleMenu() {
//     firstMobile.classList.toggle("show");
//     secondMobile.classList.toggle("show");
//     hamburgerIcon.classList.toggle("animate");
//     closeIcon.classList.toggle("animate");
//     mobileMenuToggle.classList.toggle("active");
//     mobileMenu.classList.toggle("active");
//   }

//   mobileMenuToggle.addEventListener("click", toggleMenu);
// });

// make blog cards clickable
document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".layout_latest .wrapper");

  wrappers.forEach((wrapper) => {
    const link = wrapper.querySelector(".more a");
    if (link) {
      const href = link.getAttribute("href");

      wrapper.style.cursor = "pointer";

      wrapper.addEventListener("click", function (e) {
        if (!e.target.closest("a")) {
          window.location.href = href;
        }
      });
    }
  });
});

// Main JavaScript
document.addEventListener("DOMContentLoaded", () => {
  const newslist = document.querySelector(".mod_newslist.infinite-blog");

  if (newslist) {
    const articles = newslist.children;

    if (articles.length > 3) {
      // Get the language from the HTML root element
      const lang = document.documentElement.lang.toLowerCase();

      // Determine the button text based on the language
      const buttonText = lang === "de" ? "Mehr anzeigen" : "Show more";

      // Create and add the "Load More" button
      const loadMoreButton = document.createElement("button");
      loadMoreButton.textContent = buttonText;
      // loadMoreButton.style.marginTop = "20px";

      const buttonContainer = document.createElement("div");
      buttonContainer.classList.add("pill-container");
      buttonContainer.classList.add("show-more");
      //   buttonContainer.addClass = "pill-container";
      buttonContainer.appendChild(loadMoreButton);
      newslist.after(buttonContainer);

      // Add click event listener to the button
      loadMoreButton.addEventListener("click", () => {
        Array.from(articles).forEach((article, index) => {
          if (index >= 3) {
            setTimeout(() => {
              article.classList.add("visible");
            }, 1); //  (index - 3) * 100); // Stagger the animation
          }
        });

        // Hide the button after clicking
        loadMoreButton.style.display = "none";
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const scrollLink = document.querySelector('a[href="#scrolldown"]');

  scrollLink.addEventListener("click", function (e) {
    e.preventDefault();

    const scrollDistance = window.innerHeight; // 100vh

    window.scrollTo({
      top: window.pageYOffset + scrollDistance,
      behavior: "smooth",
    });
  });
});

// make mobile menu li full clickable

document.addEventListener("DOMContentLoaded", function () {
  const mobilemenuli = document.querySelectorAll(
    ".mod_navigation .second_mobile li"
  );

  mobilemenuli.forEach((li) => {
    const link = li.querySelector("a");
    if (link) {
      const href = link.getAttribute("href");

      li.style.cursor = "pointer";

      li.addEventListener("click", function (e) {
        if (!e.target.closest("a")) {
          window.location.href = href;
        }
      });
    }
  });
});

// defien scrollbarsize

document.addEventListener("DOMContentLoaded", function () {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.body.style.setProperty("--scrollbarWidth", `${scrollbarWidth}px`);
});

// trigger resize event 2seconds after load
// fix this

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    window.dispatchEvent(new Event("resize"));
  }, 200);
});
